import React, { Component } from 'react';
import Wrapper from './style';
import { Button } from 'antd';
import { PC_MONITOR, EXCHANGE_CARD_ICON_BLACK } from '../../config/media';
import Coins from '../../components/Coins';

class ExchangePreview extends Component {
	renderPromotedAssets = () => {
		const { data } = this.props;
		const list = [];
		const exchange = data[0];
		exchange.info.biz.ASSETS.forEach((item) => {
			if (item.ASSET_PROMOTE) {
				list.push(item);
			}
		});
		if (list.length === 0) {
			return <div>Empty</div>;
		}
		return list.map((item) => {
			return (
				<div>
					<Coins type={item.ASSET_SYMBOL} small />
				</div>
			);
		});
	};

	renderPairs = () => {
		const { data } = this.props;
		const exchange = data[0];
		return exchange.info.biz.pairs.map((item) => {
			return (
				<div className="pair-card">
					<Coins type={item.BASE_ASSET} small />
					<span className="versus">VS</span>
					<Coins type={item.PRICED_ASSET} small />
				</div>
			);
		});
	};

	renderFees = () => {
		// const { data } = this.props;
		// const exchange = data[0];
		return null;
	};

	render() {
		const { data, location } = this.props;
		if (data.length === 0 && location.search === '') {
			this.props.history.goBack();
		}
		const exchange = data[0];
		const imgIndex = (exchange.id % 6) + 1;
		return (
			<Wrapper>
				<div className="preview-header">
					<img
						src={EXCHANGE_CARD_ICON_BLACK[imgIndex]}
						alt="LOGO_HOLLAEX"
						className="exchange-image"
					/>
					<h2>{exchange.name}</h2>
					<div className="preview-header-btn-wrapper">
						<Button onClick={() => this.props.history.push('/')}>
							Dashboard
						</Button>
						{/* <Button type="primary">Share this Page</Button> */}
					</div>
				</div>
				<div className="preview-body">
					<div className="pc-img">
						<img src={PC_MONITOR} alt="pc-monitor" />
					</div>
					<div className="url">
						<div className="url-domain">
							{exchange.info.tech.EXCHANGE_CLIENT_URL}
						</div>
					</div>
					<div className="preview-body-card">
						<h3>Promoted Asset</h3>
						<div>{this.renderPromotedAssets()}</div>
					</div>
					<div className="preview-body-card">
						<h3>Trading Pairs</h3>
						<div>{this.renderPairs()}</div>
					</div>
					<div className="preview-body-card">
						<h3>Deposit and Withdraw Status</h3>
						<div></div>
					</div>
					<div className="preview-body-card">
						<h3>Fee Structure</h3>
						<div></div>
					</div>
				</div>
			</Wrapper>
		);
	}
}

export default ExchangePreview;
